import { useState } from "react";
import { ACHIEVEMENT_REWARDS, ACHIEVEMENT_TARGETS, type AchievementKey } from "@frontier/content/achievements";
import { NPCS } from "@frontier/content/npcs";
import { HULLS } from "@frontier/content/definitions";
import type { AchievementControls } from "./use-achievements";
import { credits } from "./ui-labels";
import { useVisibleRefresh } from "./use-visible-refresh";
import { AchievementArt } from "./AchievementArt";
import "./achievements.css";

function title(key: AchievementKey): string {
  if (key.category === "npc") return NPCS[key.kind].name;
  if (key.category === "pvp") return HULLS[key.kind].name;
  return { energy: "Энергия", salvage: "Оборудование", contraband: "Контрабанда" }[key.kind];
}
export function AchievementPanel({ view, busy, error, reload, cancel, active = true }: AchievementControls & { active?: boolean }) {
  const [category, setCategory] = useState<AchievementKey["category"]>("npc");
  useVisibleRefresh(reload, cancel, active);
  return <section className="achievements" aria-label="Достижения" aria-busy={busy}>
    <nav className="station-activity-tabs" aria-label="Виды достижений">
      <button aria-pressed={category === "npc"} onClick={() => setCategory("npc")}>ПРОТИВНИКИ</button>
      <button aria-pressed={category === "pvp"} onClick={() => setCategory("pvp")}>КОРАБЛИ ИГРОКОВ</button>
      <button aria-pressed={category === "resource"} onClick={() => setCategory("resource")}>ДОБЫЧА</button>
    </nav>
    <div className="achievement-body">
    {error && <p role="alert">{error}</p>}
    {error && <button disabled={busy} onClick={() => void reload()}>Повторить загрузку</button>}
    {!view && busy && <p role="status">Загружаем достижения…</p>}
    <div className="achievement-grid">{view?.entries.filter(entry => entry.key.category === category).map(entry => {
      const next = ACHIEVEMENT_TARGETS[category].findIndex((_, index) => !entry.awards.some(award => award.step === index + 1));
      const target = next < 0 ? null : ACHIEVEMENT_TARGETS[category][next];
      const reward = next < 0 ? null : ACHIEVEMENT_REWARDS[next];
      const progress = target === undefined || target === null ? 0 : Number(BigInt(entry.progress) < BigInt(target) ? BigInt(entry.progress) : BigInt(target));
      return <article key={`${entry.key.category}:${entry.key.kind}`} className="achievement-card">
      <div className="achievement-heading"><AchievementArt target={entry.key} /><h3>{title(entry.key)}</h3><b>{BigInt(entry.progress).toLocaleString("ru-RU")}</b></div>
      <small>{next < 0 ? "ВСЕ СТУПЕНИ ПОЛУЧЕНЫ" : `Следующая ступень: ${progress}/${target?.toLocaleString("ru-RU")}`}</small>
      {reward && <strong className="achievement-next-reward">+{credits(reward.credits)} КР · +{reward.components} комп.</strong>}
      {target !== null && target !== undefined && <progress value={progress} max={target} aria-label={`${title(entry.key)}: следующая ступень`} />}
      <div className="achievement-steps" aria-hidden="true">{ACHIEVEMENT_TARGETS[category].map((value, index) => <span key={value} className={entry.awards.some(award => award.step === index + 1) ? "completed" : ""} />)}</div>
      <details><summary>Все ступени · получено {entry.awards.length}/4</summary><ol>{ACHIEVEMENT_TARGETS[category].map((target, index) => {
        const award = entry.awards.find(award => award.step === index + 1);
        const reward = award ?? ACHIEVEMENT_REWARDS[index];
        if (!reward) return null;
        const progress = Number(BigInt(entry.progress) < BigInt(target) ? BigInt(entry.progress) : BigInt(target));
        return <li key={target} className={award ? "completed" : ""}>
          <div><span>{target.toLocaleString("ru-RU")}</span><small>{award ? "ПОЛУЧЕНО ✓" : `${progress}/${target}`}</small></div>
          <progress value={progress} max={target} aria-label={`${title(entry.key)}: ступень ${index + 1}`} />
          <small>+{credits(reward.credits)} КР · +{reward.components} комп.</small>
        </li>;
      })}</ol></details>
    </article>;
    })}</div>
    <p className="achievement-note">{category === "npc" ? "Зачёт получает каждый нанёсший урон. Обучение и охрана станций не учитываются." : category === "pvp" ? "Подтверждённые уничтожения игроков по типу корпуса." : "Первичный подбор контейнеров. Повторный подбор своего или чужого выпавшего груза прогресс не увеличивает."}</p>
    </div>
  </section>;
}
